
export enum ENoticeTypeXsd {

    E_FORM_1 = "priorInformationNotice",
    E_FORM_2 = "priorInformationNotice",
    E_FORM_3 = "priorInformationNotice",
    E_FORM_4 = "priorInformationNotice",
    E_FORM_5 = "priorInformationNotice",
    E_FORM_6 = "priorInformationNotice",
    E_FORM_7 = "priorInformationNotice",
    E_FORM_8 = "priorInformationNotice",
    E_FORM_9 = "priorInformationNotice",
    E_FORM_10 = "priorInformationNotice",
    E_FORM_11 = "priorInformationNotice",
    E_FORM_12 = "priorInformationNotice",
    E_FORM_13 = "priorInformationNotice",
    E_FORM_14 = "priorInformationNotice",
    E_FORM_15 = "contractNotice",
    E_FORM_16 = "contractNotice",
    E_FORM_17 = "contractNotice",
    E_FORM_18 = "contractNotice",
    E_FORM_19 = "contractNotice",
    E_FORM_20 = "contractNotice",
    E_FORM_21 = "contractNotice",
    E_FORM_22 = "contractNotice",
    E_FORM_23 = "contractNotice",
    E_FORM_24 = "contractNotice",
    E_FORM_25 = "contractAwardNotice",
    E_FORM_26 = "contractAwardNotice",
    E_FORM_27 = "contractAwardNotice",
    E_FORM_28 = "contractAwardNotice",
    E_FORM_29 = "contractAwardNotice",
    E_FORM_30 = "contractAwardNotice",
    E_FORM_31 = "contractAwardNotice",
    E_FORM_32 = "contractAwardNotice",
    E_FORM_33 = "contractAwardNotice",
    E_FORM_34 = "contractAwardNotice",
    E_FORM_35 = "contractAwardNotice",
    E_FORM_36 = "contractAwardNotice",
    E_FORM_37 = "contractAwardNotice",
    E_FORM_38 = "contractAwardNotice",
    E_FORM_39 = "contractAwardNotice",
    E_FORM_40 = "contractAwardNotice",
    E_FORM_X01 = "businessRegistrationInformationNotice",
    E_FORM_X02 = "businessRegistrationInformationNotice",
    E_FORM_CEI = "priorInformationNotice",
    E_FORM_T01 = "priorInformationNotice",
    E_FORM_T02 = "contractAwardNotice"
}